import { render, staticRenderFns } from "./KipInput.vue?vue&type=template&id=235eec6e&scoped=true"
import script from "./KipInput.vue?vue&type=script&lang=js"
export * from "./KipInput.vue?vue&type=script&lang=js"
import style0 from "./KipInput.vue?vue&type=style&index=0&id=235eec6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235eec6e",
  null
  
)

export default component.exports